export default __webpack_public_path__ + "static/media/img3.34f739d0.webp";